import {styled} from '@mui/material/styles';
import { Grid } from '@mui/material';

export const LateralPanelContainer = styled(Grid)`
    @media screen and (min-width: 960px) {
        color: black;
        margin: 16px;
    };
`